<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <!-- Header -->
    <app-organization-header></app-organization-header>

    <!-- Card -->
    <div class="card">
      <div class="card-header">

        <!-- Title -->
        <h4 class="card-header-title">
          Members
        </h4>

        <!-- Dropdown -->
        <!--                <div class="dropdown">-->
        <!--                    <button class="btn btn-sm btn-primary" type="button" id="inviteMember" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
        <!--                        Invite member-->
        <!--                    </button>-->
        <!--                    <form class="dropdown-menu dropdown-menu-end dropdown-menu-card" aria-labelledby="inviteMember">-->
        <!--                        <div class="card-header">-->

        <!--                            &lt;!&ndash; Title &ndash;&gt;-->
        <!--                            <h4 class="card-header-title">-->
        <!--                                Invite a member-->
        <!--                            </h4>-->

        <!--                            &lt;!&ndash; Badge &ndash;&gt;-->
        <!--                            <span class="badge bg-primary-soft">2 seats left</span>-->

        <!--                        </div>-->
        <!--                        <div class="card-header">-->
        <!--                            <div class="row g-0 align-items-center">-->
        <!--                                <div class="col-3">-->

        <!--                                    &lt;!&ndash; Label &ndash;&gt;-->
        <!--                                    <label class="mb-0" for="inviteMemberName">-->
        <!--                                        Name-->
        <!--                                    </label>-->

        <!--                                </div>-->
        <!--                                <div class="col">-->

        <!--                                    &lt;!&ndash; Input &ndash;&gt;-->
        <!--                                    <input class="form-control form-control-flush" id="inviteMemberName" type="text" placeholder="Full name">-->

        <!--                                </div>-->
        <!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->
        <!--                        </div>-->
        <!--                        <div class="card-header">-->
        <!--                            <div class="row g-0 align-items-center">-->
        <!--                                <div class="col-3">-->

        <!--                                    &lt;!&ndash; Label &ndash;&gt;-->
        <!--                                    <label class="mb-0" for="inviteMemberEmail">-->
        <!--                                        Email-->
        <!--                                    </label>-->

        <!--                                </div>-->
        <!--                                <div class="col">-->

        <!--                                    &lt;!&ndash; Input &ndash;&gt;-->
        <!--                                    <input class="form-control form-control-flush" id="inviteMemberEmail" type="text" placeholder="Email address">-->

        <!--                                </div>-->
        <!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->
        <!--                        </div>-->
        <!--                        <div class="card-footer">-->

        <!--                            &lt;!&ndash; Button &ndash;&gt;-->
        <!--                            <button class="btn w-100 btn-primary" type="submit">-->
        <!--                                Invite member-->
        <!--                            </button>-->

        <!--                        </div>-->
        <!--                    </form>-->
        <!--                </div>-->

      </div>
      <div class="card-body">

        <!-- List group -->
        <div class="list-group list-group-flush my-n3">
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col-auto">

                <!-- Avatar -->
                <a class="avatar" href="profile-posts.html">
                  <img alt="..." class="avatar-img rounded-circle" src="assets/img/avatars/profiles/avatar-1.jpg">
                </a>

              </div>
              <div class="col-5 ms-n2">

                <!-- Title -->
                <h4 class="mb-1">
                  <a href="profile-posts.html">Dianna Smiley</a>
                </h4>

                <!-- Email -->
                <p class="small text-muted mb-0">
                  <a class="d-block text-reset text-truncate" href="mailt:dianna.smiley@company.com">dianna.smiley&#64;company.com</a>
                </p>

              </div>
              <div class="col-auto ms-auto me-n3">

                <!-- Select -->
                <select class="form-select form-select-sm" data-choices='{"searchEnabled": false}'>
                  <option>Admin</option>
                  <option>Staff</option>
                  <option>Custom</option>
                </select>

              </div>
              <div class="col-auto">

                <!-- Dropdown -->
                <div class="dropdown">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                     data-bs-toggle="dropdown"
                     href="#" role="button">
                    <i class="fe fe-more-vertical"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <a class="dropdown-item" href="#!">
                      Action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Another action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Something else here
                    </a>
                  </div>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col-auto">

                <!-- Avatar -->
                <a class="avatar" href="profile-posts.html">
                  <img alt="..." class="avatar-img rounded-circle" src="assets/img/avatars/profiles/avatar-2.jpg">
                </a>

              </div>
              <div class="col-5 ms-n2">

                <!-- Title -->
                <h4 class="mb-1">
                  <a href="profile-posts.html">Ab Hadley</a>
                </h4>

                <!-- Email -->
                <p class="small text-muted mb-0">
                  <a class="d-block text-reset text-truncate" href="mailt:ab.hadley@company.com">ab.hadleyompany.com</a>
                </p>

              </div>
              <div class="col-auto ms-auto me-n3">

                <!-- Select -->
                <select class="form-select form-select-sm" data-choices='{"searchEnabled": false}'>
                  <option>Admin</option>
                  <option>Staff</option>
                  <option>Custom</option>
                </select>

              </div>
              <div class="col-auto">

                <!-- Dropdown -->
                <div class="dropdown">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                     data-bs-toggle="dropdown"
                     href="#" role="button">
                    <i class="fe fe-more-vertical"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <a class="dropdown-item" href="#!">
                      Action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Another action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Something else here
                    </a>
                  </div>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col-auto">

                <!-- Avatar -->
                <a class="avatar" href="profile-posts.html">
                  <img alt="..." class="avatar-img rounded-circle" src="assets/img/avatars/profiles/avatar-3.jpg">
                </a>

              </div>
              <div class="col-5 ms-n2">

                <!-- Title -->
                <h4 class="mb-1">
                  <a href="profile-posts.html">Adolfo Hess</a>
                </h4>

                <!-- Email -->
                <p class="small text-muted mb-0">
                  <a class="d-block text-reset text-truncate" href="mailt:adolfo.hess@company.com">adolfo.hess&#64;company.com</a>
                </p>

              </div>
              <div class="col-auto ms-auto me-n3">

                <!-- Select -->
                <select class="form-select form-select-sm" data-choices='{"searchEnabled": false}'>
                  <option>Admin</option>
                  <option>Staff</option>
                  <option>Custom</option>
                </select>

              </div>
              <div class="col-auto">

                <!-- Dropdown -->
                <div class="dropdown">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                     data-bs-toggle="dropdown"
                     href="#" role="button">
                    <i class="fe fe-more-vertical"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <a class="dropdown-item" href="#!">
                      Action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Another action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Something else here
                    </a>
                  </div>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
          <div class="list-group-item">
            <div class="row align-items-center">
              <div class="col-auto">

                <!-- Avatar -->
                <a class="avatar" href="profile-posts.html">
                  <img alt="..." class="avatar-img rounded-circle" src="assets/img/avatars/profiles/avatar-4.jpg">
                </a>

              </div>
              <div class="col-5 ms-n2">

                <!-- Title -->
                <h4 class="mb-1">
                  <a href="profile-posts.html">Daniela Dewitt</a>
                </h4>

                <!-- Email -->
                <p class="small text-muted mb-0">
                  <a class="d-block text-reset text-truncate" href="mailt:daniela.dewitt@company.com">daniela.dewitt&#64;company.com</a>
                </p>

              </div>
              <div class="col-auto ms-auto me-n3">

                <!-- Select -->
                <select class="form-select form-select-sm" data-choices='{"searchEnabled": false}'>
                  <option>Admin</option>
                  <option>Staff</option>
                  <option>Custom</option>
                </select>

              </div>
              <div class="col-auto">

                <!-- Dropdown -->
                <div class="dropdown">
                  <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                     data-bs-toggle="dropdown"
                     href="#" role="button">
                    <i class="fe fe-more-vertical"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <a class="dropdown-item" href="#!">
                      Action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Another action
                    </a>
                    <a class="dropdown-item" href="#!">
                      Something else here
                    </a>
                  </div>
                </div>

              </div>
            </div> <!-- / .row -->
          </div>
        </div>

      </div>
    </div>

    <br>


  </div>
</div> <!-- / .row -->
